<template>
  <v-container v-if="publicUser">
    <v-btn
      @click="$router.back()"
      absolute=""
      bottom=""
      left=""
      fab
      class="mb-12"
      color="primary"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-row>
      <v-col cols="3">
        <v-avatar v-if="publicUser.avatar" width="128" height="128">
          <img :src="publicUser.avatar" />
        </v-avatar>
        <div
          v-else
          style="width:128px;height:128px"
          class="white--text primary mx-auto d-flex justify-center align-center my-auto rounded-circle display-2"
        >
          {{ initials }}
        </div>
        <div class="text--center mt-4">
          <div class="title font-weight-bold">
            {{ publicUser.firstName }} {{ publicUser.lastName }}
          </div>
          <div class="subtitle-2 text--secondary">{{ publicUser.role }}</div>
          <div
            class="caption mt-2"
            v-if="publicUser.plant && publicUser.plant.name"
          >
            <v-icon x-small>mdi-map-marker</v-icon> {{ publicUser.plant.name }}
          </div>
        </div>
      </v-col>
      <v-col cols="9">
        <v-card class="rounded-lg">
          <v-card-title class="font-weight-bold"
            >{{ publicUser.firstName }} 's Tasks</v-card-title
          >
          <v-card-text>
            <v-divider></v-divider>

            <v-list
              three-line
              v-if="filteredEvents && filteredEvents.length > 0"
            >
              <template v-for="item in filteredEvents">
                <v-list-item
                  :key="item.id"
                  :to="{
                    name: 'TaskProfile',
                    params: {
                      id: item.id,
                      uniqueId: item.uniqueId ? item.uniqueId : 'N/A',
                      taskDate: item.taskDate ? item.taskDate : 'N/A'
                    }
                  }"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="primary" dark class="mr-2">{{
                        item.type
                      }}</v-chip
                      ><v-chip color="secondary" dark class="mr-2">{{
                        item.subtype
                      }}</v-chip
                      ><v-chip
                        v-if="item.isDone"
                        color="success"
                        dark
                        class="mr-2"
                        >Done</v-chip
                      >
                      {{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.details }} &mdash;
                      {{
                        new Intl.DateTimeFormat("es-VE", {
                          dateStyle: "full",
                          timeStyle: "long"
                        }).format(item.dateCreated.toDate())
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="caption"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
            <div class="title my-4" v-else>
              🔧 {{ publicUser.firstName }} has no tasks at this time ✅
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-overlay v-else :value="true">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";
//try http://localhost:8080/#/public-profile/Lce4hRUQsKN3b6p6pTOMC3Mvnn32
export default {
  computed: {
    filteredEvents() {
      /*       const filtro = array => array.filter(r => r.id === this.$route.params.id);
      const responsablesArray = this.events.filter(e => {
        if (e.responsables) {
          filtro(e.responsables);
        }
      }); */
      const responsablesArray = this.events.filter(e =>
        e.responsables?.filter(r => r.id === this.$route.params.id)
      );
      return responsablesArray;
    },
    initials() {
      if (this.publicUser.firstName && this.publicUser.lastName) {
        return (
          this.publicUser.firstName.charAt(0) +
          "" +
          this.publicUser.lastName.charAt(0)
        );
      } else {
        return "NA";
      }
    },
    ...mapState("calendar", ["events"]),
    ...mapState("auth", ["publicUser"])
  },
  async created() {
    await this.$store.dispatch("auth/BIND_USER", this.$route.params.id);
    await this.$store.dispatch("calendar/bindCalendar");
  },
  data: () => ({
    items: [
      {
        type: "repair",
        title: "Brunch this weekend?",
        subtitle: `Curabitur aliquet quam id dui posuere blandit. Nulla porttitor accumsan tincidunt. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui.`,
        date: new Date()
      },

      {
        type: "maintenance",
        title: "Summer BBQ ",
        subtitle: `Curabitur aliquet quam id dui posuere blandit. Nulla porttitor accumsan tincidunt. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui..`,
        date: new Date()
      },

      {
        type: "reliability",
        title: "Oui oui",
        subtitle:
          "Curabitur aliquet quam id dui posuere blandit. Nulla porttitor accumsan tincidunt. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui.",
        date: new Date()
      }
    ]
  }),
  methods: {}
};
</script>

<style></style>
